<div class="passcode-page w-100">
  <div class="passcode-wrapper d-flex flex-column align-items-center justify-content-center h-100">
    <div class="logo d-flex flex-column align-items-center justify-content-center text-center">
      <img src="assets/smata-shared/Smata.png" alt="Strata Space" class="mb-2" />
    </div>
    <div class="passcode-card">
      <h2 class="card-title">Passcode</h2>
      <p class="instruction-text">Please enter the passcode sent to your {{ contactType }}.</p>
      <div class="input-group">
        <smata-single-input [formControl]="formControl.passcode" label="Passcode">
          @if (formControl.passcode.touched && formControl.passcode.hasError('required')) {
            <mat-error> Passcode is required. </mat-error>
          } @else if (formControl.passcode.touched && authStore.passcodeError()) {
            <mat-error> Incorrect passcode </mat-error>
          }
        </smata-single-input>
      </div>

      <button smataClientNgBtn class="btn btn-primary" (click)="onLogin()">Login</button>

      <div class="resend-container">
        <span>Didn't receive a passcode?</span>
        @if (resendCountdown() > 0) {
          <span> Resend new passcode in {{ resendCountdownLabel }}</span>
        } @else {
          <span class="resend-link" (click)="onResend()">Resend</span>
        }
      </div>
    </div>
  </div>
</div>
